import { useState } from "react";
import { NavLink } from "react-router-dom";

function Header(props: { noBackground?: boolean }) {
    const [open, setOpen] = useState(false);
    const toggleMenu = () => setOpen(p => !p);
    const closeMenu = () => setOpen(false);

    const links = [{
        path: "/",
        name: "Home"
    }, {
        path: "/projekte",
        name: "Projekte"
    }, {
        path: "/ueber-mich",
        name: "Über mich"
    }, {
        path: "/leistung",
        name: "Leistung"
    }, {
        path: "/kontakt",
        name: "Kontakt"
    }
    ]

    return <header className={"content-box" + (props.noBackground ? " no-background" : "")}>
        <div className="logo">
            <NavLink to="/">
                <img
                    className="menu-icon"
                    alt="Simon Adler - Filmproduktionen"
                    src={process.env.PUBLIC_URL + "/images/logo.webp"}
                />
            </NavLink>
        </div>

        <div className={open ? "menu-btn open" : "menu-btn"} onClick={toggleMenu}><span className="burger" /></div>

        <nav className={open ? "open" : ""}>
            <ul>
                {links.map(l =>
                    <li key={l.path}>
                        <NavLink
                            to={l.path}
                            onClick={closeMenu}
                            className={({ isActive }) => isActive ? "active" : ""}
                        >
                            {l.name}
                        </NavLink>
                    </li>
                )}
            </ul>
        </nav>
    </header>
}

export default Header;